// extracted by mini-css-extract-plugin
export var avatarContainer = "_72-0";
export var avatarTypingWave = "_72-i";
export var gray = "_72-f";
export var green = "_72-c";
export var icon = "_72-9";
export var image = "_72-1";
export var lg = "_72-6";
export var md = "_72-5";
export var presenceDot = "_72-b";
export var red = "_72-d";
export var sm = "_72-4";
export var status = "_72-a";
export var typingDot = "_72-h";
export var typingPill = "_72-g";
export var xl = "_72-7";
export var xs = "_72-3";
export var xxl = "_72-8";
export var xxs = "_72-2";
export var yellow = "_72-e";